module.exports = __webpack_public_path__ + "static/media/item-others-link-icon.27b0aa73.png";